import Cookies from "js-cookie";
import { ICookiePreferences } from "./ICookiePreferences";
import { GtmConsentAll } from "./GtmConsentAll";
export class GtmSetupConsent extends GtmConsentAll {
	// Tested
	Init(): void {
		const preferences: ICookiePreferences | string = Cookies.getJSON("cookie-preferences");
		if (!!preferences && typeof preferences === "object" && typeof preferences.performance === "boolean" && typeof preferences.personalisation === "boolean") this.setConsentFromPreferences(preferences);
		else this.setGtmDefaultConsent();
		this.loadGtm();
	}

	// Tested
	private setConsentFromPreferences(preferences: ICookiePreferences): void {
		const windowScope = this.windowHelper;
		windowScope.gtag = function () {
			windowScope.dataLayer = windowScope?.dataLayer || [];
			windowScope.dataLayer.push(arguments);
		};
		windowScope.gtag("consent", "default", {
			ad_storage: "granted",
			ad_user_data: preferences.performance === false ? "denied" : "granted",
			ad_personalization: preferences.performance === false ? "denied" : "granted",
			analytics_storage: preferences.performance === false ? "denied" : "granted",
			personalization_storage: preferences.personalisation === false ? "denied" : "granted",
			functionality_storage: "granted",
			security_storage: "granted",
		});
	}
}
